import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import {
  BoxProps,
  Accordion as MUIAccordion,
  AccordionDetails as MUIAccordionDetails,
  AccordionDetailsProps as MUIAccordionDetailsProps,
  AccordionProps as MUIAccordionProps,
  AccordionSummary as MUIAccordionSummary,
  AccordionSummaryProps as MUIAccordionSummaryProps,
  SxProps,
  Typography,
  TypographyProps,
} from '@mui/material';
import React, { ReactElement } from 'react';

export interface AccordionProps extends Omit<MUIAccordionProps, 'children' | 'sx'> {
  iconSize?: string | number;
  borderRadius?: string | number;
  content?: string;
  icon?: ReactElement;
  iconColor?: string;
  contentPadding?: BoxProps['padding'];
  contentProps?: Omit<TypographyProps, 'children'>;
  contentWrapperProps?: Omit<MUIAccordionDetailsProps, 'children'>;
  title: string;
  titleBgColor?: string;
  titlePadding?: BoxProps['padding'];
  titleProps?: Omit<TypographyProps, 'children'>;
  titleWrapperProps?: Omit<MUIAccordionSummaryProps, 'children'>;
  wrapperSx?: SxProps;
  wrapperBgColor?: string;
  renderContent?: () => React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({
  iconSize = '2rem',
  wrapperSx,
  wrapperBgColor,
  borderRadius = 4,
  content,
  contentProps,
  contentWrapperProps,
  contentPadding = '40px 64px',
  title,
  titleProps,
  titleBgColor,
  titleWrapperProps,
  titlePadding = 4,
  iconColor = 'white',
  icon,
  renderContent,
  ...rest
}: AccordionProps) => {
  return (
    <MUIAccordion
      disableGutters
      sx={{
        '&.MuiAccordion-root': {
          borderRadius,
          overflow: 'hidden',
          backgroundColor: wrapperBgColor,
          '&::before': {
            display: 'none',
          },
        },
        ...wrapperSx,
      }}
      {...rest}>
      <MUIAccordionSummary
        expandIcon={icon || <ArrowDropDownRoundedIcon sx={{ width: iconSize, height: iconSize, color: iconColor }} />}
        sx={{
          '&.MuiAccordionSummary-root': {
            padding: titlePadding,
            backgroundColor: titleBgColor,
          },
        }}
        {...titleWrapperProps}>
        <Typography {...titleProps}>{title}</Typography>
      </MUIAccordionSummary>
      <MUIAccordionDetails
        sx={{
          '&.MuiAccordionDetails-root': {
            padding: contentPadding,
          },
        }}
        {...contentWrapperProps}>
        {renderContent ? renderContent() : <Typography {...contentProps}>{content}</Typography>}
      </MUIAccordionDetails>
    </MUIAccordion>
  );
};

export { Accordion };
